// API Base URL Configuration
// Uses relative URLs so API calls always go to the same origin
// This avoids deployment environment variable issues
export const API_BASE_URL = '';
